// removed by extract-text-webpack-plugin
module.exports = {"slideshow-container":"kU1e8NSral8ME7tMTfEJa","slideshow":"_3wEnSo99P8grqAZUo6hhxP","nozoom":"_1jT82Y5Y0fSp18cOX3urGR","zoom":"_17xsQqW7HvPfn11SI-oqh0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Slideshow/Slideshow.scss
// module id = 2749
// module chunks = 0